import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const cycle = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutes(Math.floor(Math.random() * 14) + 1);
      setShow(true);
      hideTimer = window.setTimeout(() => setShow(false), 5000);
    };
    const first = window.setTimeout(cycle, 6000);
    const interval = window.setInterval(cycle, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:left-5 sm:right-auto sm:w-[360px]" aria-live="polite" data-id="element-43" data-mp="164ekslrri2q2">
      <AnimatePresence data-id="element-44" data-mp="1fvspd7yklsq2">
        {show && !dismissed && <motion.div key={`${buyer.name}-${minutes}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-2xl ring-1 ring-plum-100" data-id="element-45" data-mp="1fv97fr8x74c1">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-plum-50 object-contain" data-id="element-46" data-mp="s6hjxd69za5l" />
            <div className="min-w-0" data-id="element-47" data-mp="28jok474kxak7">
              <p className="text-sm font-bold text-plum-950" data-id="element-48" data-mp="28imvt0yjyrkj">
                {buyer.name} from {buyer.country}
              </p>
              <p className="text-xs text-slate-600" data-id="element-49" data-mp="2aol7cla0kq6y">just purchased the Pediatric Feeding Therapy Blueprint™</p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-mint-700" data-id="element-50" data-mp="2fneapkvl70te">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-51" data-mp="2kn0obvfbuj2q" />
                Verified purchase · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700" aria-label="Close notification" data-id="element-52" data-mp="2pjrbt3tgogy6">
              <XIcon className="h-4 w-4" data-id="element-53" data-mp="21uoobfc5btvr" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}